/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {QuantityCriterionContract} from '../../api/contracts/quantity-criterion.contract';
import {QuantityCriterionModel} from './quantity-criterion.model';

export class QuantityCriterionMapper {

    static fromQuantityCriterionContract(input: QuantityCriterionContract): QuantityCriterionModel {
        let model: QuantityCriterionModel;

        if (input != null) {
            model = {
                lesserThan: input?.lesserThan,
                biggerThan: input?.biggerThan
            };
        }
        return model;
    }

    static toQuantityCriterionContract(input: QuantityCriterionModel): QuantityCriterionContract {
        let contract: QuantityCriterionContract;

        if (input != null) {
            contract = {
                lesserThan: input?.lesserThan,
                biggerThan: input?.biggerThan
            };
        }
        return contract;
    }
}
